import ReportsAuditorApp from "./ReportsAuditorApp"

const ReportsAuditorConfig = {
	settings: {
		layout: {}
	},
	routes: [
		{
			path: 'reportsAuditor',
			element: <ReportsAuditorApp />
		}
	]
};

export default ReportsAuditorConfig;
